import { ConfirmationReviewVariant } from '../types/types';

export const useGetConfirmationReviewVariant = () =>
  // eslint-disable-next-line no-underscore-dangle -- This is a global variable
  window.__PLO_FEATURES__?.VARIANTS.successPageFeedback as ConfirmationReviewVariant | undefined;
